import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ErrorRouteBoundary } from "@/src/common/components/error-route-boundary";
import { OWNER_ROUTES } from "@/src/owner/constants/owner-routes";
import { OwnerRouteLayout } from "@/src/owner/layouts/owner-route-layout";

const BookingDetailPage = lazy(() => import("@/src/owner/pages/booking-detail-page"));
const BookingsPage = lazy(() => import("@/src/owner/pages/bookings-page"));
const CalendarPage = lazy(() => import("@/src/owner/pages/calendar-page"));
const CautionDetailPage = lazy(() => import("@/src/owner/pages/caution-detail-page"));
const CautionNewPage = lazy(() => import("@/src/owner/pages/caution-new-page"));
const CautionsPage = lazy(() => import("@/src/owner/pages/cautions-page"));
const ContractTemplateFormPage = lazy(() => import("@/src/owner/pages/contract-template-form-page"));
const ContractViewPage = lazy(() => import("@/src/owner/pages/contract-view-page"));
const ContractTemplatesPage = lazy(() => import("@/src/owner/pages/contract-templates-page"));
const CreateBookingPage = lazy(() => import("@/src/owner/pages/create-booking-page"));
const DashboardOverviewPage = lazy(() => import("@/src/owner/pages/dashboard-overview-page"));
const PropertiesPage = lazy(() => import("@/src/owner/pages/properties-page"));
const PropertyDetailPage = lazy(() => import("@/src/owner/pages/property-detail-page"));
const PropertyFormPage = lazy(() => import("@/src/owner/pages/property-form-page"));
const PropertyLengthDiscountsPage = lazy(() => import("@/src/owner/pages/property-length-discounts-page"));
const PropertyPricingPage = lazy(() => import("@/src/owner/pages/property-pricing-page"));
const RevenuePage = lazy(() => import("@/src/owner/pages/revenue-page"));
const SettingsPage = lazy(() => import("@/src/owner/pages/settings-page"));
const TenantDetailPage = lazy(() => import("@/src/owner/pages/tenant-detail-page"));
const TenantsPage = lazy(() => import("@/src/owner/pages/tenants-page"));

export const ownerRoutes: RouteObject = {
	element: <OwnerRouteLayout />,
	errorElement: <ErrorRouteBoundary />,
	children: [
		{ path: OWNER_ROUTES.DASHBOARD, element: <DashboardOverviewPage /> },
		{ path: OWNER_ROUTES.PROPERTIES, element: <PropertiesPage /> },
		{ path: OWNER_ROUTES.PROPERTY_NEW, element: <PropertyFormPage /> },
		{ path: OWNER_ROUTES.PROPERTY_DETAIL, element: <PropertyDetailPage /> },
		{ path: OWNER_ROUTES.PROPERTY_EDIT, element: <PropertyFormPage /> },
		{ path: OWNER_ROUTES.PROPERTY_PRICING, element: <PropertyPricingPage /> },
		{ path: OWNER_ROUTES.PROPERTY_LENGTH_DISCOUNTS, element: <PropertyLengthDiscountsPage /> },
		{ path: OWNER_ROUTES.BOOKINGS, element: <BookingsPage /> },
		{ path: OWNER_ROUTES.BOOKING_NEW, element: <CreateBookingPage /> },
		{ path: OWNER_ROUTES.BOOKING_DETAIL, element: <BookingDetailPage /> },
		{ path: OWNER_ROUTES.CONTRACT_VIEW, element: <ContractViewPage /> },
		{ path: OWNER_ROUTES.CALENDAR, element: <CalendarPage /> },
		{ path: OWNER_ROUTES.TENANTS, element: <TenantsPage /> },
		{ path: OWNER_ROUTES.TENANT_DETAIL, element: <TenantDetailPage /> },
		{ path: OWNER_ROUTES.CAUTIONS, element: <CautionsPage /> },
		{ path: OWNER_ROUTES.CAUTION_NEW, element: <CautionNewPage /> },
		{ path: OWNER_ROUTES.CAUTION_DETAIL, element: <CautionDetailPage /> },
		{ path: OWNER_ROUTES.REVENUE, element: <RevenuePage /> },
		{ path: OWNER_ROUTES.TEMPLATES, element: <ContractTemplatesPage /> },
		{ path: OWNER_ROUTES.TEMPLATE_NEW, element: <ContractTemplateFormPage /> },
		{ path: OWNER_ROUTES.TEMPLATE_EDIT, element: <ContractTemplateFormPage /> },
		{ path: OWNER_ROUTES.SETTINGS, element: <SettingsPage /> },
	],
};
